import { render, staticRenderFns } from "./WCrmRatingModal.vue?vue&type=template&id=a950fba2&scoped=true&"
import script from "./WCrmRatingModal.vue?vue&type=script&lang=js&"
export * from "./WCrmRatingModal.vue?vue&type=script&lang=js&"
import style0 from "./WCrmRatingModal.vue?vue&type=style&index=0&id=a950fba2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a950fba2",
  null
  
)

export default component.exports